import "./lazysizes"
import "./helper"
import "./modernizr.custom.min"

window.Cookies = require("js-cookie")
window.URI = require("urijs")
